import BigNumber from 'bignumber.js'
import masterChefABI from 'config/abi/masterchef.json'
import multicall from 'utils/multicall'
import { getMasterChefAddress } from 'utils/addressHelpers'

// MasterChef's pendingCake counts the time since a farm's last update at the full reward rate, but stakers only get
// 74.79% of it (the rest goes to the dev and reserve wallets). Running updatePool first, in the same read-only
// multicall, settles that time the way a harvest does, so pendingCake then returns what a harvest pays.
export const getPendingToonCalls = (masterChefAddress: string, pids: number[], account: string) =>
  pids.flatMap((pid) => [
    { address: masterChefAddress, name: 'updatePool', params: [pid] },
    { address: masterChefAddress, name: 'pendingCake', params: [pid, account] },
  ])

// Multicall results come back in call order: updatePool (no output), then pendingCake, for each farm
export const parsePendingToon = (results: any[]): BigNumber[] =>
  results.filter((_, index) => index % 2 === 1).map((result) => new BigNumber(result[0].toString()))

// TOON a harvest would pay now, per pid
const fetchPendingToon = async (pids: number[], account: string): Promise<BigNumber[]> => {
  const masterChefAddress = getMasterChefAddress()
  try {
    return parsePendingToon(await multicall(masterChefABI, getPendingToonCalls(masterChefAddress, pids, account)))
  } catch (error) {
    // One failing farm fails the whole batch, so read the farms one by one
    return Promise.all(
      pids.map(async (pid) => {
        try {
          const results = await multicall(masterChefABI, getPendingToonCalls(masterChefAddress, [pid], account))
          return parsePendingToon(results)[0]
        } catch (e) {
          console.warn(`Failed to fetch pending TOON for pid ${pid}`, e)
          return new BigNumber(0)
        }
      }),
    )
  }
}

export default fetchPendingToon
